import React from 'react'
import PropTypes from 'prop-types'
import { defineMessages, useIntl } from 'react-intl'

// Utils
import AuthError from '../../features/auth/AuthError'

// Components
import { If } from '../../deprecated/Conditionals'
import Loading from '../../Components/shared/Loading/LoadingApp'
import OverlayMask from '../../Components/shared/Routing/OverlayMask'
import AppHeader from './AppHeader'
import { SkipNavLink, Text } from '@homebot/shared-ui-swashbuckle'

const MSG = defineMessages({
  skiptocontent: {
    id: 'General.a11y.skiptocontent',
    defaultMessage: 'Skip to Content',
  },
})

const AppLayout = ({
  children,
  enableAgentDropdown,
  error,
  loading,
  match,
  ...restProps
}) => {
  const appHeaderProps = {
    enableAgentDropdown,
    ...restProps,
  }

  const intl = useIntl()

  return (
    <>
      <If condition={loading}>
        <Loading />
      </If>
      <OverlayMask loading={loading} isExact={match.isExact}>
        <SkipNavLink>
          <Text>{intl.formatMessage(MSG.skiptocontent)}</Text>
        </SkipNavLink>
        <AppHeader {...appHeaderProps} />
        <If condition={!error}>{children}</If>
      </OverlayMask>
      <AuthError />
    </>
  )
}

AppLayout.propTypes = {
  children: PropTypes.any,

  enableAgentDropdown: PropTypes.bool,
  error: PropTypes.bool,

  loading: PropTypes.bool,
  match: PropTypes.shape({
    isExact: PropTypes.bool,
  }),
}

export default AppLayout
